/* LP Faro horeca: kop volgt de advertentie (utm_content bevat H1..H6 of ?hook=H3), rekenhulp, advertentienaam in het formulier. */
(function () {
  'use strict';
  var root = document.getElementById('lph');
  if (!root) return;
  var q; try { q = new URLSearchParams(location.search); } catch (e) { q = { get: function () { return ''; } }; }
  var ad = q.get('utm_content') || '', m = (q.get('hook') || ad).match(/\bH\s*-?\s*([1-6])\b/i);
  if (m && root.querySelector('[data-hook="H' + m[1] + '"]')) {
    root.querySelectorAll('[data-hook]').forEach(function (el) { el.hidden = el.getAttribute('data-hook') !== 'H' + m[1]; });
  }
  try { if (ad || q.get('utm_campaign')) sessionStorage.setItem('lph_ad', [q.get('utm_campaign'), ad].filter(Boolean).join(' / ')); } catch (e) {}
  var adField = document.getElementById('lph-ad');
  try { if (adField) adField.value = sessionStorage.getItem('lph_ad') || ''; } catch (e) {}

  var variant = root.getAttribute('data-variant');
  var m2 = document.getElementById('lph-m2'), hrs = document.getElementById('lph-h');
  var outN = document.getElementById('lph-n'), outKg = document.getElementById('lph-kg'), btn = document.getElementById('lph-calc-btn');
  function calc() {
    var a = Math.max(5, parseFloat(m2.value) || 0), h = Math.max(1, parseFloat(hrs.value) || 0);
    var n = Math.max(1, Math.ceil(a / 12));
    outN.textContent = n;
    outKg.textContent = (Math.round(n * h * 0.4 * 10) / 10).toLocaleString('nl-NL') + '–' + (Math.round(n * h * 0.5 * 10) / 10).toLocaleString('nl-NL');
    var code = n >= 6 ? 'FARO6' : n >= 2 ? 'FARO' + n : '';
    btn.href = '/cart/' + variant + ':' + n + (code ? '?discount=' + code : '');
    btn.textContent = n > 6 ? 'Bestel ' + n + ' met FARO6 of vraag een offerte' : 'Bestel ' + n + (code ? ' met ' + code : ' stuk');
  }
  if (m2 && hrs && outN && btn) { m2.addEventListener('input', calc); hrs.addEventListener('input', calc); calc(); }

  function track(ev, data) { try { window.dataLayer && window.dataLayer.push(Object.assign({ event: ev }, data || {})); } catch (e) {} }
  root.querySelectorAll('.lph-tier__btn, #lph-calc-btn').forEach(function (a) {
    a.addEventListener('click', function () { track('lph_order_click', { qty: a.getAttribute('data-qty') || (outN && outN.textContent) }); });
  });
  var form = document.getElementById('lph-form');
  if (form) form.addEventListener('submit', function () {
    track('generate_lead', { form: 'faro-horeca' });
    try { window.fbq && window.fbq('track', 'Lead', { content_name: 'Faro horeca offerte' }); } catch (e) {}
  });
  if (document.querySelector('.lph-ok, .lph-err')) document.getElementById('offerte').scrollIntoView();
})();
